module.exports={
    "两次输入的密码必须一致": "중복 입력한 비밀번호는 반드시 일치해야 합니다.",
    "取消": "취소",
    "如验证出现问题，请点击": "인증 문제 발생 시 눌러 주세요.",
    "如验证出现问题，请联系orcalivecs@asiainnovations.com": "인증 문제 발생 시 orcalivecs@asiainnovations.com로 문의 바랍니다.",
    "如验证出现问题，请联系upcs@asiainnovations.com": "인증 문제 발생 시 upcs@asiainnovations.com로 문의 바랍니다.",
    "密码修改成功": "비밀번호 수정 성공",
    "密码格式错误": "올바른 비밀번호 형식이 아닙니다.",
    "密码由6-20位由数字和字母组成": "비밀번호는 6-20자 영문, 숫자를 사용해 주세요",
    "恭喜您密码重置成功": "비밀번호가 재설정 되었습니다.",
    "恭喜您已成功激活帐户": "축하드려요! 귀하의 계정이 활성화 되었습니다.",
    "知道了": "확인",
    "确认修改": "수정 확인",
    "网络连接有误, 请稍后再试": "네트워크 연결 오류. 잠시 후 다시 시도해주세요.",
    "联系客服": "고객센터 연결",
    "请再次输入密码": "비밀번호를 다시 입력해 주세요.",
    "请返回UpVoice中重新进行邮箱验证": "UpVoice로 돌아가 이메일 계정으로 인증해 주세요.",
    "请返回Up直播中重新进行邮箱验证": "Uplive로 돌아가 이메일 계정으로 다시 로그인 하세요.",
    "请返回虎鲸直播中重新进行邮箱验证": "Orcalive로 돌아가 이메일 계정으로 인증해 주세요.",
    "请重新设定登录密码": "비밀번호를 다시 설정해 주세요",
    "请重新设置密码": "비밀번호를 다시 설정해 주세요",
    "赶快返回UpVoice中与全球潮人互动吧": "Uplive로 돌아가 글로벌 친구들과 소통하세요!",
    "赶快返回Up直播中与全球潮人互动吧！": "Uplive로 돌아가 글로벌 친구들과 소통하세요!",
    "赶快返回虎鲸直播中与全球潮人互动吧": "Orcalive로 돌아가 글로벌 친구들과 소통하세요!",
    "重置密码失败": "비밀번호 재설정 실패",
    "验证失败": "인증 실패",
    "验证成功": "인증 성공!"
};


// WEBPACK FOOTER //
// ./js/lang/kokr.js